import { Overview, Plans } from '@/components/Setting';

export default {
  name: 'Setting',
  components: {
    Overview,
    Plans,
  },
  computed: {
    component() {
      return this.$route.params.action || 'overview';
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
};
